import { defineStore } from 'pinia'

function markSelected(items) {
    if (!Array.isArray(items)) return []
    return items.map(item => ({
        ...item,
        is_selected: typeof item.is_selected === 'boolean' ? item.is_selected : true
    }))
}

export const useCvStore = defineStore('cv', {
    state: () => ({
        cvData: {
            photo: '',
            title: '',
            birth_year: '',
            region_residence: '',
            competences: [],
            summary: '',
            employment: [],
            education: [],
            languages: [],
        },
    }),
    actions: {
        updateSection(section, value) {
            if (['competences', 'employment', 'education', 'languages'].includes(section)) {
                this.cvData[section] = markSelected(value)
            } else {
                this.cvData[section] = value
            }
        },
        toggleSelection(section, identifier) {
            if (!this.cvData[section] || !Array.isArray(this.cvData[section])) return;

            this.cvData[section] = this.cvData[section].map(item => {
                return item.id === identifier ?
                    {...item, is_selected: !item.is_selected } :
                    item;
            });
        }
    }
})